import {Component, inject} from '@angular/core';
import {FormArray, FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {UserService} from '../../../../services/user.service';
import {MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {MatError, MatFormField, MatInput, MatLabel} from '@angular/material/input';
import {MatButton, MatIconButton} from '@angular/material/button';
import {VulcanIconComponent} from '@eagle-i/vulcan-component-library';
import {CdkTextareaAutosize} from '@angular/cdk/text-field';
import {CreateApiKeyRequest} from '../../../../core/classes/apiKeyRequest';


@Component({
  selector: 'tgrid-update-api-key-modal',
  imports: [
    ReactiveFormsModule,
    MatDialogModule,
    MatFormField,
    MatLabel,
    MatInput,
    MatButton,
    MatIconButton,
    VulcanIconComponent,
    CdkTextareaAutosize,
    MatError,
  ],
  templateUrl: './request-api-key-modal.component.html',
  styleUrl: './request-api-key-modal.component.scss',
})
export class RequestApiKeyModalComponent {
  private fb = inject(FormBuilder);
  private userService = inject(UserService);
  private dialogRef = inject(MatDialogRef<RequestApiKeyModalComponent>);

  protected saving = false;

  protected form: FormGroup = this.fb.group({
    description: ['', {validators: [Validators.maxLength(1000), Validators.required], nonNullable: true}],
    supportedSystems: this.fb.array([this.createSupportedSystemControl()]),
  });

  // Form Array handlers

  protected get supportedSystems(): FormArray<FormControl<string>> {
    return this.form.get('supportedSystems') as FormArray<FormControl<string>>;
  }

  private createSupportedSystemControl(value: string = ''): FormControl<string> {
    return this.fb.control(value, {
      validators: [Validators.maxLength(255), Validators.required],
      nonNullable: true,
    });
  }

  protected addSupportedSystem(): void {
    this.supportedSystems.push(this.createSupportedSystemControl(''));
  }

  protected removeSupportedSystem(index: number): void {
    if (this.supportedSystems.length <= 1) {
      this.supportedSystems.at(0).setValue('');
      return;
    }
    this.supportedSystems.removeAt(index);
  }


  protected cancel(): void {
    this.dialogRef.close(false);
  }

  protected save(): void {
    if (this.form.invalid || this.saving) return;
    this.saving = true;

    const raw: {description: string, supportedSystems: string[]} = this.form.getRawValue();
    const payload: CreateApiKeyRequest = {
      reason: raw.description.trim(),
      supportedSystems: raw.supportedSystems
        .filter((system) => !!system)
        .map((system) => system.trim()),
    };

    this.userService.requestApiKey(payload).subscribe({
      next: (updated) => {
        this.saving = false;
        this.dialogRef.close(updated);
      },
      error: () => {
        this.saving = false;
      },
    });
  }
}
